
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  configurationCountryHeadline: {
    id: "ConfigurationCountry.headline",
    defaultMessage: "What country does your configuration belong to?",
  },
  configurationCountryButton: {
    id: "ConfigurationCountry.button",
    defaultMessage: "Accept",
  },
  configurationCountrySelect: {
    id: "ConfigurationCountry.select",
    defaultMessage: "Please select a country...",
  },
  configurationCountryRunning: {
    id: "ConfigurationCountry.running",
    defaultMessage: "(running)",
  }
});

export default MESSAGES;